<!-- Maqueta: indicadores.php / `.contenedorValores` de cuerpo.css, en filas (2026-10-09): arriba
     las dos de validacion, debajo produccion e incidencias, y al final las ultimas facturas, que la
     maqueta no tiene en Inicio y el usuario quiere. Cada fila salta de linea si no cabe. -->
<div class="indicadores">
    <div class="fila-grupos" *ngFor="let fila of filas; let f = index">
        <div class="grupo" *ngFor="let grupo of fila">
            <span class="titulo-grupo">{{ grupo.titulo }}</span>
            <div class="fila">
                <div class="indicador mostrar" *ngFor="let indicador of grupo.indicadores"
                     [style.animation-delay.s]="f * 0.2" (click)="irA(indicador.link)">
                    <ng-template [cdkPortalOutlet]="indicador.portal"></ng-template>
                </div>
            </div>
        </div>
    </div>
    <div class="fila-grupos">
        <div class="grupo facturas">
            <span class="titulo-grupo">Últimas facturas</span>
            <div class="ficha mostrar" [style.animation-delay.s]="0.4">
                <app-ultimas-facturas></app-ultimas-facturas>
            </div>
        </div>
    </div>
</div>
